module.exports = __webpack_public_path__ + "static/media/Patients.dfc82855.png";